<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 13L5 8L10 3"
      stroke="#222222"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
